import React from 'react';
import { FormErrorSC } from './form-error.styled';

interface FormErrorProps {
  children: React.ReactNode;
}

const FormError: React.FunctionComponent<FormErrorProps> = ({ children }) => {
  return (
    <FormErrorSC display="body3" variant="default">
      {children}
    </FormErrorSC>
  );
};

export default FormError;
